export default __webpack_public_path__ + "static/media/perros.e6154504.gif";